import React from 'react';

interface PacificCrossIconProps {
  className?: string;
}

const PacificCrossIcon: React.FC<PacificCrossIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M3 8h10M8 3v10" stroke="currentColor" strokeWidth="1"/>
    <path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" strokeWidth="0.5"/>
  </svg>
);

export default PacificCrossIcon;